import styled from 'styled-components';

export const List = styled.ul`
  list-style-type: disc;
  color: ${({ theme: { colors } }) => colors.dark_500};
  li {
    margin-top: ${({ theme: { spacing } }) => spacing.spacing_08};
  }
`;
